/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseChannel } from '../../models/api-response-channel';
import { Channel } from '../../models/channel';

export interface CreateChannel$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: Channel
}

export function createChannel(http: HttpClient, rootUrl: string, params: CreateChannel$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseChannel>> {
  const rb = new RequestBuilder(rootUrl, createChannel.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseChannel>;
    })
  );
}

createChannel.PATH = '/v1/api/ui/channel';
